import { Component, LOCALE_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NotificationModalComponent } from './shared/components/notification-modal/notification-modal.component';
import { UpdateBannerComponent } from './shared/components/update-banner/update-banner.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, NotificationModalComponent, UpdateBannerComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    providers: [{ provide: LOCALE_ID, useValue: 'es_PY' }]
})
export class AppComponent {
    title = 'ERP - ARCO 3.0';
}
